import { inject, Injectable } from "@angular/core";
import { PerfilUserService } from "../../features/perfil-user/service/perfil-user.service";
import { AppState } from "../../store/app.state";
import { Store } from "@ngrx/store";
import { setBalance } from "../../features/perfil-user/store/balance.actions";

@Injectable({
  providedIn: 'root'
})
export class UpdateBalanceFirebaseHandler {

  private _perfilService = inject(PerfilUserService);
  private _store = inject(Store<AppState>);


  updateBalance() {
    this._perfilService.getProfile().subscribe({
      next: (profile) => {
        this._store.dispatch(setBalance({ balance: profile.data.balance }));
        // console.log('Balance actualizado:', profile.data.balance);
      },
      error: (profileErr) => {
        console.error('Error al obtener perfil:', profileErr);
      }
    });
  }
}
